/**
 * Billing-specific formatting utilities.
 * Used by PA-7 self-service billing UI components.
 */

/**
 * Format amount in cents to PLN currency string.
 * @example formatCents(12345) => "123,45 zl" (locale-dependent)
 */
export const formatCents = (cents: number): string => {
  return new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
  }).format(cents / 100);
};

/**
 * Format ISO date string to Polish locale compact date (DD.MM.YYYY).
 * Returns em-dash for null/undefined dates.
 * @example formatBillingDate('2026-03-13') => "13.03.2026"
 */
export const formatBillingDate = (date?: string | null): string => {
  if (!date) return '\u2014';
  return new Date(date).toLocaleDateString('pl-PL');
};
